module.exports = __webpack_public_path__ + "png/balance4.png?85303cd7bdbd65e7e699fecbca55f73a";